import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_LOOKUPDATA_LIST_ID");

const expand =
  "expand=fields(select=id,CustomId,Title,Code,Namespace,Color,IsDefault)";

export class LookupDataService {
  static async getList() {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        return res.data?.value?.map((item: any) => (LookupDataService.mapData(item)));
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static mapData(item: any) { 
    return {
      Id: item.fields.CustomId,
      Title: item.fields.Title,
      Code: item.fields.Code,
      Namespace: item.fields.Namespace,
      Color: item.fields.Color,
      IsDefault: item.fields.IsDefault
    }
  }
}
